import { render, staticRenderFns } from "./bindWechat.vue?vue&type=template&id=2628c842&"
import script from "./bindWechat.vue?vue&type=script&lang=js&"
export * from "./bindWechat.vue?vue&type=script&lang=js&"
import style0 from "./bindWechat.vue?vue&type=style&index=0&id=2628c842&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports